import { render, staticRenderFns } from "./documentAdd.vue?vue&type=template&id=c06d6170&scoped=true&"
import script from "./documentAdd.vue?vue&type=script&lang=js&"
export * from "./documentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d6170",
  null
  
)

export default component.exports